import React from 'react';

// import animations and other components
import Wobble from 'react-reveal/Wobble';
import Bounce from 'react-reveal/Bounce';
import { Fade, Flip } from 'react-reveal';
// import ProgressSlide from './ProgressSlide';
import { Link } from 'react-scroll';
import { Helmet } from 'react-helmet';

const About = () => {
  return (
    <section className='section lg:min-h-[100vh] bg-secondary' id='about'>
      <Helmet>
        <title>About MD. Nahid | Full-Stack Web Developer</title>
        <meta name="description" content="Experienced Full-Stack Developer with a strong foundation in MERN stack. Skilled in building responsive, high-performance applications that combine intuitive user interfaces with efficient back-end functionality." />
        <meta name="keywords" content="Full-Stack Developer, MD Nahid, MERN Stack, Web Development, React Developer, Next.js, Node.js, Express.js, Responsive Design, Web Applications, User Engagement" />
      </Helmet>
      <div className='container mx-auto'>
        <div className='flex flex-col w-full mx-auto xl:flex-row items-center gap-3'>
          <Wobble>
            <div className="w-4/6 lg:w-2/6 mx-auto">
              <img
                className='object-cover h-full w-full mx-auto md:mx-auto lg:mx-0 rounded-2xl'
                src="https://res.cloudinary.com/dsigyjfjq/image/upload/fl_preserve_transparency/v1741697633/SDDS_elnmwb.jpg"
                alt='MD Nahid - Full-Stack Web Developer'
              />
            </div>
          </Wobble>
          <div className='flex w-5/6 lg:w-3/6 mx-auto flex-col items-center text-center lg:items-start lg:text-left'>
            <div className='flex flex-col'>
              <Flip duration={2000}>
                <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                  MD. NAHID
                </h2>
                <p className='mb-4 text-accent'>
                  Full-Stack Web Developer
                </p>
              </Flip>
              <hr className='mb-8 opacity-5' />
              <p className='mb-8'>
                <Bounce left>
                  As a Full-Stack Developer, I bring expertise in the MERN stack—MongoDB, Express, React, and Node.js—to build robust, dynamic web applications. My skillset allows me to seamlessly integrate intuitive front-end designs with efficient, scalable back-end functionality.
                </Bounce>
                <br />
                <br />
                <Bounce right>
                  I’m passionate about creating solutions that enhance user experience and performance. Known for my commitment to quality and attention to detail, I thrive in environments where innovation and efficiency meet, ensuring that each project is not only functional but also memorable and impactful.
                </Bounce>
              </p>
            </div>
            <Fade bottom>
              <Link to="contact" activeClass='active' spy={true} smooth={true} duration={500} offset={-70} className='btn btn-md bg-accent hover:bg-secondary-hover cursor-pointer transition-all duration-300'>
                Contact me
              </Link>
            </Fade>
          </div>
        </div>
      </div>
      {/* <div className="">
        <ProgressSlide />
      </div> */}
    </section>
  );
};

export default About;
